module.exports = __webpack_public_path__ + "static/img/63fbdeaca5435678113ad2405b87f68b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T41.jpg
// module id = 2Rj2
// module chunks = 1